import type { UseInfiniteQueryResult } from '@tanstack/react-query';

import type { CommunicationPagination } from '@/api/fe-api/entities/communication';

import { CommunicationSidebarHeader } from './communication-sidebar-header';
import { CommunicationSidebarList } from './communication-sidebar-list';

type CommunicationSidebarProps = {
  listResult: UseInfiniteQueryResult<CommunicationPagination>;
};

export function CommunicationSidebar({
  listResult,
}: CommunicationSidebarProps) {
  return (
    <div className="flex h-full flex-col">
      <div>
        <CommunicationSidebarHeader />
      </div>
      <div className="flex-1 overflow-y-auto">
        <CommunicationSidebarList listResult={listResult} />
      </div>
    </div>
  );
}
